import {SagaIterator} from 'redux-saga';
import {Opt} from 'ts-opt';
import {select} from 'typed-redux-saga';

import {AnimalList} from 'api/gen/AnimalList';
import {State} from 'app/setup';

/**
 * Resolves the saved-list id for a given animal-list name.
 *
 * @param name Saved animal-list name.
 * @returns The numeric id of the matching saved list.
 */
export function* getAnimalListId(name: string): SagaIterator<number> {
    const animalLists: Opt<Array<AnimalList>> =
        (yield* select((state: State) => state.animalBrowser.animalLists));
    const animalListId = animalLists
        .findIn(y => y.name === name)
        .prop('id')
        .orCrash('animalLists not available');

    return animalListId;
}
